/* EVENTS INVOLVING TEMPLATES */

module.exports = {
    dashboard_templates_visit: { // visit the templates page, no additional data
        excludeSuperAdmin: true,
        getProps: ({}) => {
            return {}
        }
    },
    dashboard_templates_visit_close: { // leave the templates page, no additional data
        excludeSuperAdmin: true,
        getProps: ({}) => {
            return {}
        }
    },
    dashboard_single_template_visit: { // visit the templates page, no additional data
        excludeSuperAdmin: true,
        getProps: ({dashboard}) => {
            return {
                templateId: dashboard.id,
                templateName: dashboard.title,
                categories: dashboard.Categories.map(cat => cat.name)
            }
        }
    },
    dashboard_single_template_visit_close: { // leave the templates page, no additional data
        excludeSuperAdmin: true,
        getProps: ({dashboard}) => {
            return {
                templateId: dashboard.id,
                templateName: dashboard.title,
                categories: dashboard.Categories.map(cat => cat.name)
            }
        }
    },
}